export default __webpack_public_path__ + "static/media/formulario_alvara_vs4.55c4d1ce.docx";